import { useCallback, useState } from 'react'
import { type UnitOfMeasure, formatPointsForDisplay } from '@/lib/units/unit-conversion'
import type {
  DimensionValues,
  DisplayPrecision,
  FormatForDisplay,
  PanelFieldErrors,
  PositionValues,
} from '../types/panel-fields'

/** Text-field state for X/Y/W/H: displayed values, inline errors and preserved decimal precision. */
export function usePanelFields(unitOfMeasure: UnitOfMeasure) {
  const [position, setPosition] = useState<PositionValues>({ x: '', y: '' })
  const [dimensions, setDimensions] = useState<DimensionValues>({ width: '', height: '' })
  const [fieldErrors, setFieldErrors] = useState<PanelFieldErrors>({})
  /** Preserves user-entered decimal precision across panel sync. */
  const [displayPrecision, setDisplayPrecision] = useState<DisplayPrecision>({})

  const formatForDisplay: FormatForDisplay = useCallback(
    (points: number, field?: 'x' | 'y' | 'width' | 'height', decimalPlaces?: number) => {
      const dp = decimalPlaces ?? (field ? displayPrecision[field] : undefined)

      return formatPointsForDisplay(
        points,
        unitOfMeasure,
        dp !== undefined ? { decimalPlaces: dp } : undefined
      )
    },
    [unitOfMeasure, displayPrecision]
  )

  return {
    position,
    setPosition,
    dimensions,
    setDimensions,
    fieldErrors,
    setFieldErrors,
    setDisplayPrecision,
    formatForDisplay,
  }
}
